import { render, staticRenderFns } from "./weightLimitForm.vue?vue&type=template&id=b2071a56&"
import script from "./weightLimitForm.vue?vue&type=script&lang=js&"
export * from "./weightLimitForm.vue?vue&type=script&lang=js&"
import style0 from "./weightLimitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2071a56')) {
      api.createRecord('b2071a56', component.options)
    } else {
      api.reload('b2071a56', component.options)
    }
    module.hot.accept("./weightLimitForm.vue?vue&type=template&id=b2071a56&", function () {
      api.rerender('b2071a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceWeightLimit/components/weightLimitForm.vue"
export default component.exports